import { useNavigate } from 'react-router-dom';
import { subscribePath } from '../../utils/afterAuth';

const usePlanStart = () => {
  const navigate = useNavigate();

  return (planKey) => {
    if (localStorage.getItem('token')) {
      // Con sesion: el plan gratis ya lo tiene; los de pago, a suscribirse con ese plan marcado
      navigate(planKey === 'free' ? '/dashboard' : subscribePath(planKey));
      return;
    }
    if (planKey !== 'free') {
      localStorage.setItem('selectedSubscription', planKey);
    }
    navigate('/sign-up');
  };
};

export default usePlanStart;
